export const getDataCategories = store => store.data_categories.data;
